const CreateDate = (date) => {
  console.log(date);
  var currentDate = new Date(date);
  var dd = String(currentDate.getDate()).padStart(2, "0");
  var mm = String(currentDate.getMonth() + 1).padStart(2, "0");
  var yyyy = currentDate.getFullYear();
  return yyyy + "-" + mm + "-" + dd;
};
module.exports = CreateDate;
